export default "__VITE_ASSET__4d64cc26__"